export default __webpack_public_path__ + "static/media/portrait-placeholder.157f088b.png";